
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { IBTNCONF } from '@/types/base.d';
import { IOrgForm } from '@/types/org.d';
import { tSearch } from '@/components/Search/index';
import bModal from './components/bModal.vue';
import tableMixin from './tableMixin';

@Component({
  components: {
    Pagination,
    bModal,
    tSearch,
  },
})
export default class ManageView extends Mixins(tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/org/manage:add',
    icon: 'plus',
    callback: this.handleAddForm,
    log: {
      name: '机构管理 - 新增',
      component: 'org/mange/components/bModal',
    },
  }];

  private visible: boolean = false;

  private title: string = '添加机构';

  private form: IOrgForm = {
    orgTitle: '',
    loginName: '',
    orgBackup: '',
  };

  /**
   * @author liangyongmou
   * @desc 添加机构
   */
  handleAddForm() {
    this.title = '添加机构';
    this.visible = true;
  }

  /**
   * @author liangyongmou
   * @desc 编辑机构
   * @param { any } row 行数据
   */
  handleUpdateForm(row: any) {
    this.form = {
      orgTitle: row.orgTitle,
      loginName: row.loginName,
      orgBackup: row.orgBackup,
      pid: row.pid,
    };
    this.title = '编辑机构';
    this.visible = true;
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }

  handleAdvancedSearch(searchValue: string) {
    this.getData({ t: searchValue });
  }
}
